"use client";

import FlightDealItemSkeleton from "./FlightDealItem.skeleton";
import { Col, Row } from "antd";

interface FlightDealsDesktopSkeletonProps {
  type?: 'DOMESTIC' | 'INTERNATIONAL'
}

const FlightDealsDesktopSkeleton = ({ type }: FlightDealsDesktopSkeletonProps) => {

  return (
    <Row gutter={[15, 15]}>
      {[1, 2, 3, 4].map((flight) => (
        <FlightDealItemSkeleton key={flight} type={type} />
      ))}
    </Row>
  );
};

export default FlightDealsDesktopSkeleton;
